import { createSlice } from '@reduxjs/toolkit';
import io from 'socket.io-client';
import { SOCKET_URL } from '../../../config/config';

const initialState = {
    socket: null,
    socketId: null,
    isConnected: false,
    socket: null,
};

const socketSlice = createSlice({
    name: 'socket',
    initialState,
    reducers: {
        setSocketId(state, action) {
            state.socketId = action.payload;
        },
        setSocket(state, action) {
            state.socket = action.payload;
        },
        setSocketConnectionStatus(state, action) {
            state.isConnected = action.payload;
        },
        disconnectSocket(state) {
            state.socketId = null;
            state.isConnected = false;
        },
    },
});

export const { setSocket, setSocketId, setSocketConnectionStatus, disconnectSocket } = socketSlice.actions;

export const connectSocket = () => (dispatch) => {
    const token = localStorage.getItem('authToken');
    const socketInstance = io(SOCKET_URL, {
        auth: { token },
    });

    dispatch(setSocket(socketInstance));

    socketInstance.on('connect', () => {
        dispatch(setSocketId(socketInstance.id));
        dispatch(setSocketConnectionStatus(true));
    });


    socketInstance.on('disconnect', () => {
        dispatch(setSocketConnectionStatus(false));
    });

    return socketInstance
};

export default socketSlice.reducer;